import { render } from "./LoadingModal.vue?vue&type=template&id=588dd2fa&scoped=true"
import script from "./LoadingModal.vue?vue&type=script&lang=js"
export * from "./LoadingModal.vue?vue&type=script&lang=js"

import "./LoadingModal.vue?vue&type=style&index=0&id=588dd2fa&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\PeD\\ApontaFacil\\dashboard\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588dd2fa"]])

export default __exports__